export default "__VITE_ASSET__fb18f031__"